import { useEffect, useState } from "react";
import DIN276AssetProperties from "./object-properties/DIN276AssetProperties";
import { userAPI } from "./UserAPI";

import { Label } from "@/components/ui/label";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";

export default function TestDIN276() {
    const [metadata, setMetadata] = useState([]);
    const [selectedType, setSelectedType] = useState() as any;
    const [asset, setAsset] = useState({}) as any;

    useEffect(() => {

        const call = async () => {
            const newMetadata = await userAPI.getDIN276Metadata();

            //console.log('Metadata >>>', newMetadata);
            setMetadata(newMetadata);
        };

        call();
    }, []);

    const sortedTypes = [...metadata].sort((x: any, y: any) => {
        const xs = x.code.split('.');
        const ys = y.code.split('.');

        if (Number(xs[0]) !== Number(ys[0])) {
            return Number(xs[0]) - Number(ys[0]);
        } else {
            return Number(xs[1]) - Number(ys[1]);
        }
    });

    return <div className="p-8">
        <div className="grid w-full max-w-[400px] gap-2">
            <Label htmlFor="din276-type">DIN 276 Typen</Label>
            <Select
                value={selectedType ? String(selectedType.code) : undefined}
                onValueChange={(key) => setSelectedType(metadata.find((x: any) => String(x.code) === key))}
            >
                <SelectTrigger id="din276-type">
                    <SelectValue placeholder="Bitte auswählen ..." />
                </SelectTrigger>
                <SelectContent>
                    {sortedTypes.map((type: any) => (
                        <SelectItem key={String(type.code)} value={String(type.code)}>
                            {`${type.code} (${type.name})`}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
        {selectedType
            ?
            <div className="mt-6 flex flex-wrap gap-4">
                <DIN276AssetProperties readonly type={selectedType.code} properties={asset} setProperties={setAsset}></DIN276AssetProperties>
                <DIN276AssetProperties type={selectedType.code} properties={asset} setProperties={setAsset}></DIN276AssetProperties>
            </div>
            :
            <></>
        }
    </div>;
};
